<template>
  <div>
    <b-row>
      <b-col md="2">
        <b-form-input v-model="searchFilter" :placeholder="$t('recherche_label')" size="sm"></b-form-input>
      </b-col>
      <b-col md="2">
        <b-form-select v-model="courseFilter" :options="inscriptions.list_courses" size="sm"></b-form-select>
      </b-col>
      <b-col md="2">
        <b-button-group>
          <b-button size="sm" class="sex_select_button" v-on:click="sexeFilter = ''"
            v-bind:class="{ sex_selected_button: sexeFilter === '' }">
            <v-icon name="male" />
            <v-icon name="female" />
          </b-button>
          <b-button size="sm" class="sex_select_button" v-on:click="sexeFilter = 'HOMME'"
            v-bind:class="{ sex_selected_button: sexeFilter === 'HOMME' }">
            <v-icon name="male" />
          </b-button>
          <b-button size="sm" class="sex_select_button" v-on:click="sexeFilter = 'FEMME'"
            v-bind:class="{ sex_selected_button: sexeFilter === 'FEMME' }">
            <v-icon name="female" />
          </b-button>
        </b-button-group>
      </b-col>
      <b-col md="3">
        <!-- <b-button-group>
          <b-button style="white-space: nowrap; padding: 5px 9px !important" size="sm" class="sex_select_button" v-on:click="sortby = 'name'" v-bind:class="{ sex_selected_button: sortby === 'name' }">
            <b-icon icon="sort-alpha-down"></b-icon> Par nom
          </b-button>
          <b-button style="white-space: nowrap; padding: 5px 9px !important" size="sm" class="sex_select_button" v-on:click="sortby = 'doss'" v-bind:class="{ sex_selected_button: sortby === 'doss' }">
            <b-icon icon="sort-numeric-down"></b-icon> Par doss
          </b-button>
        </b-button-group> -->
      </b-col>
      <b-col md="3">
        <b-pagination v-model="page" :total-rows="inscriptions.nb_inscriptions" :per-page="perPage"
          aria-controls="table-inscriptions"></b-pagination>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="3">
        <b-form-select v-model="catFilter" :options="list_categories" size="sm"></b-form-select>
      </b-col>
      <b-col md="3">
        <b-form-select v-model="paysFilter" :options="inscriptions.list_pays" size="sm"></b-form-select>
      </b-col>
    </b-row>
    <p class="count-table" v-if="$store.state.module.base != 'TSV22'">
      {{ (page - 1) * perPage }}
      {{ $t("splitter_pagination") }}
      <span v-if="page * perPage < inscriptions.nb_inscriptions">{{ page * perPage }}</span><span v-else>{{
        inscriptions.nb_inscriptions }}</span> /
      {{ inscriptions.nb_inscriptions }}
    </p>
    <transition name="fade">
      <b-table v-if="inscriptions && inscriptions.list" style="margin-top: 10px" id="table-inscriptions" small hover
        responsive :tbody-tr-class="row_femme" :items="inscriptions.list" :fields="fields"
        :per-page="inscriptions.list.length">
        <template #head(dossard)>
          <b-button style="white-space: nowrap" size="sm" class="live_filter_btn_header_row"
            v-on:click="sortby = 'doss'" v-bind:class="{ sex_selected_button: sortby === 'doss' }">
            <b-icon icon="sort-numeric-down"></b-icon> {{ $t("dossard") }}
          </b-button>
        </template>
        <template #head(nom)>
          <b-button style="white-space: nowrap" size="sm" class="live_filter_btn_header_row"
            v-on:click="sortby = 'name'" v-bind:class="{ sex_selected_button: sortby === 'name' }"> <b-icon
              icon="sort-alpha-down"></b-icon> {{ $t("nom") }} </b-button>
        </template>
        <template #head(itra)>
          <p style="min-width: 80px">
            <b-button style="white-space: nowrap; height: 100% !important" size="sm"
              class="live_filter_btn_header_row itra_filter_btn" v-on:click="sortby = 'itra'"
              v-bind:class="{ sex_selected_button: sortby === 'itra' }">
              <b-icon icon="sort-numeric-down"></b-icon> <img src="../../assets/Logo_itra_Simple_N blanc.png" alt="itra"
                class="itra_logo_filter" />
            </b-button>
          </p>
        </template>

        <template #cell(dossard)="row">
          <span v-html="formated_dossard(row.item)"></span>
        </template>
        <template #cell(course)="row">
          <span v-html="formated_courses(row.item)"></span>
        </template>
        <template #cell(nom)="row">
          <span v-html="formated_nom(row.item)"></span>
        </template>
        <template #cell(prenom)="row">
          <span v-html="formated_prenom(row.item)"></span>
        </template>
        <template #cell(sexe)="row">
          <p class="sexe-icon-male" v-if="row.item.sexe === 'M'">M</p>
          <p class="sexe-icon-female" v-else-if="row.item.sexe === 'F'">F</p>
          <p class="sexe-icon-mixte" v-else>M/F</p>
        </template>
        <template #cell(pays)="row">
          <p class="text-nowrap">
            <img class="flag" :src="'https://sportips.fr/live/img/Flags/' + row.item.nation + '.jpg'" />
            {{ row.item.pays }}
          </p>
        </template>
        <template #cell(cotation)="row">
          <p v-if="parseInt(row.item.cotation) != 50" style="cursor: help" v-b-tooltip.hover :title="'L\'indice de performance Sportips est calculé à partir de vos classements lors des courses Sportips.Un indice de ' +
            parseInt(row.item.cotation) +
            '/100 signifie que vous êtes mieux classé que ' +
            parseInt(row.item.cotation) +
            '% des autres coureurs du même sexe. (Par défaut à 50)'
            ">
            {{ row.item.cotation }}
          </p>
          <p v-else>-</p>
        </template>

        <template #cell(paiement_recu)="row">
          <div :class="[row.item.paiement_recu ? 'green_cell' : 'red_cell']">
            <b-icon class="icon_ok" v-if="row.item.paiement_recu" icon="check" aria-hidden="true"></b-icon>
            <b-icon class="icon_not_ok" v-else icon="x" aria-hidden="true"></b-icon>
          </div>
        </template>
        <template #cell(fichier_recu)="row">
          <div :class="[row.item.fichier_recu ? 'green_cell' : 'red_cell']">
            <b-icon class="icon_ok" v-if="row.item.fichier_recu" icon="check" aria-hidden="true"></b-icon>
            <b-icon class="icon_not_ok" v-else icon="x" aria-hidden="true"></b-icon>
          </div>
        </template>
        <template #cell(valide)="row">
          <div :class="[row.item.valide ? 'green_cell' : 'red_cell']">
            <b-icon class="icon_ok" v-if="row.item.valide" icon="check" aria-hidden="true"></b-icon>
            <b-icon class="icon_not_ok" v-else icon="x" aria-hidden="true"></b-icon>
          </div>
        </template>
      </b-table>
    </transition>
    <transition name="fade">
      <div v-if="inscriptions.list && inscriptions.list.length === 0 && !$store.state.loading">
        <h3>{{ $t("tab_inscriptions.erreur_aucune_inscription") }}</h3>
        <router-link to="courses"><b-button class="inline-btn">{{ $t("retour") }}</b-button></router-link>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "@/components/Loading.vue";
export default {
  components: { Loading },
  data() {
    return {
      list_categories: [this.$t("toutes_categories"), "ES", "SE", "M0", "M1", "M2", "M3", "M4", "M5", "M6", "M7", "M8", "M9", "M10", "JU", "CA", "MI", "BE", "PO", "EA", "BB"],
      inscriptions: {},
      courseFilter: this.$t("tous_parcours"),
      paysFilter: this.$t("tous_pays"),
      catFilter: this.$t("toutes_categories"),
      sortby: "name",
      searchFilter: "",
      sexeFilter: "",
      perPage: 30,
      page: 1,
      fields: [
        {
          key: "dossard",
          sortable: false,
          label: this.$t("dossard"),
        },

        {
          key: "nom",
          sortable: false,
          label: this.$t("nom"),
        },
        {
          key: "prenom",
          sortable: false,
          label: this.$t("prenom"),
        },
        {
          key: "itra",
          sortable: false,
          label: "Itra",
        },
        {
          key: "pays",
          sortable: false,
          label: this.$t("pays"),
        },
        {
          key: "cat",
          sortable: false,
          label: this.$t("cat"),
        },
        {
          key: "sexe",
          sortable: false,
          label: this.$t("sexe"),
        },
        {
          key: "club",
          sortable: true,
        },
        {
          key: "course",
          sortable: false,
          label: this.$t("course"),
        },
        {
          key: "cotation",
          sortable: false,
          label: "Indice",
        },
        {
          key: "paiement_recu",
          sortable: false,
          label: this.$t("paiement"),
        },
        {
          key: "fichier_recu",
          sortable: false,
          label: this.$t("documents"),
        },
        {
          key: "valide",
          sortable: false,
          label: this.$t("valide"),
        },
      ],
    };
  },
  watch: {
    page() {
      this.fetchInscriptions();
    },
    courseFilter() {
      this.page = 1;
      this.fetchInscriptions();
    },
    paysFilter() {
      this.page = 1;
      this.fetchInscriptions();
    },
    searchFilter() {
      this.page = 1;
      this.fetchInscriptions();
    },
    sexeFilter() {
      this.page = 1;
      this.fetchInscriptions();
    },
    catFilter() {
      this.page = 1;
      this.fetchInscriptions();
    },
    sortby() {
      this.page = 1;
      this.fetchInscriptions();
    },
  },
  methods: {
    formated_dossard(item) {
      let content = "";
      let list_dossard = item.dossard.split(" + ");
      for (var i = 0; i < list_dossard.length; i++) {
        if (!item.id_coureur_live || !item.id_coureur_live[i] || item.id_coureur_live[i] == 0) {
          content += list_dossard[i] + " ";
        } else {
          content += "<a class='formated_link' style='color:#212529;' target='_blank' href='/race/" + this.$store.state.module.base + "/fiche/" + item.id_coureur_live[i] + "'>" + list_dossard[i] + "</a> ";
        }

      }
      return content;
    },
    formated_courses(item) {
      let content = "";
      let list_courses = item.course.split(" || ");

      for (var i = 0; i < list_courses.length; i++) {
        if (!item.id_coureur_live || !item.id_coureur_live[i] || item.id_coureur_live[i] == 0) {
          content += list_courses[i] + " ";
        } else {
          content += "<a class='formated_link' style='color:#212529;' target='_blank' href='/race/" + this.$store.state.module.base + "/fiche/" + item.id_coureur_live[i] + "'>" + list_courses[i] + "</a> ";
        }
      }

      return content;
    },
    formated_nom(item) {
      if (!item.id_coureur_live || item.id_coureur_live == 0) {
        return item.nom;
      }
      return "<a class='formated_link' style='color:#212529;' target='_blank' href='/race/" + this.$store.state.module.base + "/fiche/" + item.id_coureur_live + "'>" + item.nom + "</a>";
    },
    formated_prenom(item) {
      if (!item.id_coureur_live || item.id_coureur_live == 0) {
        return item.prenom;
      }
      return "<a class='formated_link' style='color:#212529;' target='_blank' href='/race/" + this.$store.state.module.base + "/fiche/" + item.id_coureur_live + "'>" + item.prenom + "</a>";
    },
    buildEndpoint(init = false) {
      var url = "";

      if (this.$store.state.module.nm == "1") {
        url = "/nm/inscription/get.php?base=" + this.$store.state.module.base;
      } else {
        url = "/inscription/get.php?base=" + this.$store.state.module.base;
      }
      if (init) {
        url += "&action=init";
        return url;
      }

      if (this.searchFilter != "") {
        url += "&search=" + this.searchFilter;
      }
      if (this.catFilter != this.$t("toutes_categories")) {
        var filter = this.catFilter;
        var split = this.catFilter.split(" / ");

        if (split.length > 0) {
          filter = split[0];
        }

        url += "&cat=" + filter;
      }
      if (this.paysFilter != this.$t("tous_pays")) {
        url += "&pays=" + this.paysFilter;
      }
      if (this.courseFilter != this.$t("tous_parcours")) {
        url += "&course=" + encodeURIComponent(this.courseFilter);
      }
      if (this.sexeFilter != "") {
        url += "&sexe=" + this.sexeFilter;
      }
      if (this.sortby === "doss") {
        url += "&sortby=doss";
      }
      if (this.sortby === "itra") {
        url += "&sortby=itra";
      }
      url += "&page=" + (this.page - 1);
      return url;
    },
    fetchInscriptions() {
      this.$store.commit("setLoading");
      var _this = this;
      var endpoint = this.buildEndpoint();
      axios.get(this.$store.state.base_url + endpoint).then(function (response) {
        _this.inscriptions.list = response.data.list;
        _this.inscriptions.nb_inscriptions = response.data.nb_inscriptions;
        if (_this.$store.state.module.base === "EMORC22") {
          _this.handleEMORCChallenge();
        }

        _this.$store.commit("unsetLoading");
        _this.$forceUpdate();
      });
    },

    row_femme(item, type) {
      if (!item || type !== "row") return;
      if (item.sexe === "F") return "row-femme";
    },

    handleEMORCChallenge() {
      this.list_categories = [this.$t("toutes_categories"), "M 35 / W 35", "M 40 / W 40", "M 45 / W 45", "M 50 / W 50", "M 55 / W 55", "M 60 / W 60", "M 65 / W 65", "M 70 / W 70", "M 75 / W 75", "M 80 / W 80"];
      // WIP C'est pas beau, à généraliser
      var inscriptions_to_add = [];
      if (this.inscriptions.list) {
      }
      var inscriptions = JSON.parse(JSON.stringify(this.inscriptions.list));
      if (!(inscriptions && inscriptions.length > 0)) {
        return;
      }
      for (var i = 0; i < inscriptions.length; i++) {
        if (inscriptions[i].course === "TRAIL RUNNING 40km + Uphill 10km Master Championship") {
          var new_inscription_1 = JSON.parse(JSON.stringify(inscriptions[i]));
          var new_inscription_2 = JSON.parse(JSON.stringify(inscriptions[i]));
          new_inscription_1.course = "TRAIL RUNNING 40km Master Championship";
          new_inscription_2.course = "MOUNTAIN RUNNING 10km (Uphill) Master Championship";
          inscriptions_to_add.push(new_inscription_1);
          inscriptions_to_add.push(new_inscription_2);
        }
      }

      var filtered_inscriptions = inscriptions.filter((item) => item.course && item.course !== "TRAIL RUNNING 40km + Uphill 10km Master Championship");
      for (var i = 0; i < inscriptions_to_add.length; i++) {
        filtered_inscriptions.push(inscriptions_to_add[i]);
      }
      if (this.courseFilter === "TRAIL RUNNING 40km Master Championship" || this.courseFilter === "MOUNTAIN RUNNING 10km (Uphill) Master Championship") {
        filtered_inscriptions = filtered_inscriptions.filter((item) => item.course === this.courseFilter);
      }

      this.inscriptions.list = filtered_inscriptions;

      this.inscriptions.list_courses = this.inscriptions.list_courses.filter((e) => e !== "TRAIL RUNNING 40km + Uphill 10km Master Championship");
    },
  },
  created() {
    this.$store.commit("setLoading");
    var _this = this;
    let endpoint = this.buildEndpoint(true);
    axios.get(this.$store.state.base_url + endpoint).then(function (response) {
      _this.inscriptions = response.data;
      _this.inscriptions.list_courses.unshift(_this.$t("tous_parcours"));
      _this.inscriptions.list_pays.unshift(_this.$t("tous_pays"));

      if (_this.$store.state.module.base === "EMORC22") {
        _this.handleEMORCChallenge();
      }

      _this.$store.commit("unsetLoading");
      _this.$forceUpdate();
    });
  },
};
</script>

<style lang="scss">
.formated_link {
  text-decoration: underline !important;
}

.formated_link:hover {
  cursor: pointer !important;
}
</style>